// extracted by mini-css-extract-plugin
export default {"section3Wrapper":"Section3_section3Wrapper__m3tLc","overlay":"Section3_overlay__pDzqD","content":"Section3_content__lw79i","ctaButton":"Section3_ctaButton__PYUYD"};